/*
 * @Author: proudlx
 * @Description:路由前置守卫
 */
import router from "./router";
import store from "./store";
import Tea from "@dp/byted-tea-sdk-oversea";
let date = new Date();
let isOnce = false;
window.addEventListener("unload", () => {
  // 页面卸载时 抛出当前页面停留时间
  const newDate = new Date();
  Tea.event("page_duration", {
    duration: Math.floor((newDate.getTime() - date.getTime()) / 1000),
    client: window.location.pathname.indexOf("mobile") > -1 ? "mobile" : "PC",
    full_path: window.location.href,
    path: window.location.pathname,
  });
});
router.beforeEach((to, from, next) => {
  console.log("to.path", to);
  console.log("from.path", from);
  const newDate = new Date();
  if (from.path !== "/") {
    console.log("页面停留时长", newDate.getTime() - date.getTime());
    Tea.event("page_duration", {
      duration: Math.floor((newDate.getTime() - date.getTime()) / 1000),
      client: from.path.indexOf("mobile") > -1 ? "mobile" : "PC",
      full_path: from.fullPath,
      path: from.path,
      ...from.query,
    });
    date = newDate;
  }
  if (!isOnce) {
    Tea.event("page_enter", {
      client: to.path.indexOf("mobile") > -1 ? "mobile" : "PC",
      full_path: to.fullPath,
      path: to.path,
      channel: to.query.channel || "normal",
    });
    isOnce = true;
  }
  if (to.path.indexOf("loginBefore") > -1) {
    store.commit("SET_REDIRECT_INFO", from);
  }
  if (window.matchMedia("(max-width: 767px)").matches) {
    if (to.path.indexOf("operate") > -1) {
      console.log("移动设备");
      if (to.path.indexOf("courseContent") > -1) {
        next({
          path: "/mobile/courseContent",
          query: to.query,
        });
      } else if (to.path.indexOf("operate/course") > -1) {
        next({
          path: "/mobile/course",
          query: to.query,
        });
      } else {
        console.log("移动设备1");
        next("/mobile/index");
      }
    }
    // console.log("这是一个移动设备。", to)
  } else {
    if (to.path.indexOf("mobile") > -1) {
      if (to.path.indexOf("courseContent") > -1) {
        next({
          path: "/operate/courseContent",
          query: to.query,
        });
      } else if (to.path.indexOf("mobile/course") > -1) {
        next({
          path: "/operate/course",
          query: to.query,
        });
      } else if (to.path.indexOf("mobile/agentReport") > -1) {
        next();
      } else {
        next("/operate/index");
      }
    }
    // console.log("这是平板电脑或台式电脑。")
  }
  // 参数携带登录信息并且本地没有登录令牌
  if (to.query.ident && !localStorage.getItem(process.env.VUE_APP_TOKEN_KEY)) {
    console.log("参数携带登录信息并且本地没有登录令牌");
    store
      .dispatch("Login", { ident: to.query.ident })
      .catch((err) => {
        console.info("登录异常", err);
      })
      .finally(() => {
        next();
      });
  } else {
    // store有登录信息或本地没有登录令牌
    if (
      store.getters.isLogin ||
      !localStorage.getItem(process.env.VUE_APP_TOKEN_KEY)
    ) {
      next();
    } else {
      store.dispatch("GetInfo").finally(() => {
        console.log("获取用户信息完成");
        next();
      });
    }
  }
});

router.afterEach(() => {
  //   NProgress.done()
  window.scrollTo(0, 0);
});
